import {useLoaderData, useRouteLoaderData} from '@remix-run/react'
import {useReportWidgetClick, useReportWidgetSeen, useSendPartnerProductClickoutCustom} from '~/hooks/analytic-hooks'
import {IconRightArrowLightWeight} from '~/icons/home-page/brg-icon-app-logo-thick'
import {getTranslation} from '~/localization/translation'
import type {CategoriesDataProps, RootLoaderResponse} from '~/types'

const PromotedProducts = () => {
  const {language, locale} = useRouteLoaderData('root') as RootLoaderResponse
  const {promotedProducts} = useLoaderData<CategoriesDataProps>()
  const translations = getTranslation(language)
  const sendWidgetClickEvent = useReportWidgetClick()
  const [widgetRef] = useReportWidgetSeen({
    widget_name: 'home-page-related-products',
    widget_place: 'bottom',
  })
  const reportClickout = useSendPartnerProductClickoutCustom()

  return (
    <div className="mb-5 flex justify-center" ref={widgetRef}>
      <section className="relative mb-6 mt-6 flex w-full flex-col rounded-3xl bg-neutral-100 pb-8 pl-6 pr-6 pt-8">
        <p className="mb-2 text-2xl font-bold leading-8" data-testid="promoted-products-title">
          {translations.Home.RelatedProducts.title}
        </p>

        <div className="no-scrollbar relative mt-2 flex flex-row gap-5 overflow-x-scroll">
          {promotedProducts.map((product, index) => {
            return (
              <a
                className="flex max-h-72 min-h-72 min-w-48 max-w-48 flex-col rounded-lg bg-white px-4"
                key={`${product.asin}-${index}`}
                href={product.affiliateLink.url}
                rel="nofollow noreferrer"
                target="_blank"
                aria-label={`view ${product.name}`}
                onClick={() => {
                  sendWidgetClickEvent({
                    widget_name: 'related-product-card',
                    widget_place: 'bottom',
                  })
                  reportClickout({
                    index: index,
                    item_list_id: product.asin || '',
                    click_element_name: 'home-page',
                    partner_item_brand: product.brand || '',
                    partner_item_id: product.asin || '',
                    item_name: product.name || '',
                    item_brand: product.brand || '',
                    item_category: undefined,
                    click_id: product.affiliateLink?.clickId,
                    affiliation: product.affiliateLink?.type || '',
                    is_dws: true,
                    location_id: locale,
                    traffic: 'unknown',
                    gclid: undefined,
                    sys_id: undefined,
                    target: product.affiliateLink?.url || '',
                  })
                }}
              >
                <div className="mb-7 mt-5 flex h-32 items-center justify-center bg-white">
                  <img src={product.image} alt={product.name} className="h-32 w-auto object-contain" />
                </div>
                <p className="line-clamp-2 text-base font-normal text-neutral-500">{product.name}</p>
                <div className="mb-5 mt-auto flex flex-row items-center justify-center gap-2">
                  <p className="text-base font-normal text-neutral-900 underline">{translations.Home.viewDeal}</p>
                  <IconRightArrowLightWeight className="h-5 w-5" />
                </div>
              </a>
            )
          })}
        </div>
      </section>
    </div>
  )
}

export default PromotedProducts
